"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signatureToWeb3Extension = void 0;
const proto_1 = require("@evmos/proto");
function signatureToWeb3Extension(chain, sender, hexFormattedSignature) {
    let signature = hexFormattedSignature;
    const temp = hexFormattedSignature.split('0x');
    if (temp.length === 2) {
        ;
        [, signature] = temp;
    }
    return (0, proto_1.createWeb3Extension)(chain.chainId, sender.accountAddress, Uint8Array.from(Buffer.from(signature, 'hex')));
}
exports.signatureToWeb3Extension = signatureToWeb3Extension;
//# sourceMappingURL=web3Extension.js.map